import { render } from "./AddPostView.vue?vue&type=template&id=6a6bd0a1"
import script from "./AddPostView.vue?vue&type=script&lang=js"
export * from "./AddPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__